const groupPrefix = 'files'

export const apiFiles = {
	fetchFile: async (id: string) => {
		const { data } = await apiCommon<IFile>(`${groupPrefix}/${id}`, { method: 'GET' })
		return FileJSON(data)
	},

	uploadFile: async (collection: string, file: IFileModel) => {
		const formData = new FormData()
		formData.append('file', file, file.name)
		const { data } = await apiCommon<IFile>(`${groupPrefix}/${collection}`, { method: 'POST', body: formData })
		return FileJSON(data)
	},

	updateFile: async (id: number, file: IFileModel) => {
		const formData = new FormData()
		formData.append('file', file, file.name)
		const { data } = await apiCommon<IFile>(`${groupPrefix}/${id}`, { method: 'PUT', body: formData })
		return FileJSON(data)
	},

	deleteFile: async (id: string) => {
		const data = await apiCommon<string>(`${groupPrefix}/${id}`, { method: 'DELETE' })
		return data
	},

	uploadImage: async (modelID: number, modelType: EFileModelType, file: File, collection: EFileCollection) => {
		const formData = new FormData()
		formData.append('file', file, file.name)
		formData.append('collection', collection)

		const { data } = await apiCommon<{ data: IFile }>(`files/${modelType}/${modelID}`, {
			method: 'POST',
			body: formData,
		})
		return FileFromJSON(data)
	},
}
